import ChatBubbleOutline from '@mui/icons-material/ChatBubbleOutline';
import HelpCenter from '@mui/icons-material/HelpCenter';
import HelpOutline from '@mui/icons-material/HelpOutline';
import ScheduleOutlined from '@mui/icons-material/ScheduleOutlined';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import TravelExplore from '@mui/icons-material/TravelExplore';
// import StarsIcon from '@mui/icons-material/Stars';
// import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
// import PaidIcon from '@mui/icons-material/Paid';
import NewChatIcon from '@/assets/images/icons-outline/edit-square-icon.svg?react';
import { Section } from '@/components/muiComponents';
import { isDemoEnvironment } from '@/util/demoUtils';
import { BuildCircle } from '@mui/icons-material';

const iconProps = {
  sx: { p: '2px' },
  size: 'medium',
};

const isDemo = isDemoEnvironment();

let navTopSectionConfig: Section[] = [
  {
    name: 'menu.newChat',
    icon: NewChatIcon,
    heading: false,
    subSections: [
      {
        name: 'menu.newChat',
        path: '/chat',
        accessKey: 'NEW_CHAT',
      },
    ],
  },
  {
    name: 'menu.history',
    icon: ScheduleOutlined,
    heading: true,
    subSections: [
      {
        name: 'menu.history',
        path: '#',
        accessKey: 'HISTORY',
      },
    ],
  },
  {
    name: 'menu.explore',
    icon: TravelExplore,
    heading: true,
    subSections: [
      {
        name: 'menu.explore',
        path: '#',
        accessKey: 'EXPLORE',
      },
      // {
      //   name: 'menu.performance',
      //   icon: (
      //     <StarsIcon
      //       {...iconProps}
      //       sx={{
      //         color: '#FFD700',
      //       }}
      //     />
      //   ),
      //   path: '/explore/performance',
      //   accessKey: 'EXPLORE',
      // },
      // {
      //   name: 'menu.transactions',
      //   icon: (
      //     <PaidIcon
      //       {...iconProps}
      //       sx={{
      //         color: '#4CAF50',
      //       }}
      //     />
      //   ),
      //   path: '/explore/transactions',
      //   accessKey: 'EXPLORE',
      // },
      // {
      //   name: 'menu.marketing',
      //   icon: (
      //     <AutoAwesomeIcon
      //       {...iconProps}
      //       sx={{
      //         color: '#F44336',
      //       }}
      //     />
      //   ),
      //   path: '/explore/marketing',
      //   accessKey: 'EXPLORE',
      // },
      {
        name: 'menu.support',
        icon: (
          <HelpCenter
            {...iconProps}
            sx={{
              color: '#9C27B0',
            }}
          />
        ),
        path: '/explore/support',
        accessKey: 'EXPLORE',
      },
      {
        name: 'menu.toolkit',
        icon: (
          <BuildCircle
            {...iconProps}
            sx={{
              color: '#FF6600',
            }}
          />
        ),
        path: '/explore/toolkit',
        urlLink: process.env.REACT_APP_TOOLKIT_URL || '',
        accessKey: 'EXPLORE',
      },
    ],
  },
];

navTopSectionConfig = !isDemo
  ? navTopSectionConfig
  : navTopSectionConfig.filter((section) => section.name !== 'menu.history');

export { navTopSectionConfig };

export const navBottomSectionsConfig: Section[] = [
  {
    name: 'menu.help',
    icon: HelpOutline,
    subSections: [
      {
        name: 'menu.help',
        path: '/help',
        accessKey: 'HELP',
      },
    ],
  },
  {
    name: 'menu.liveChat',
    icon: ChatBubbleOutline,
    subSections: [
      {
        name: 'menu.liveChat',
        path: '/live-chat',
        accessKey: 'LIVE_CHAT',
      },
    ],
  },
  {
    name: 'menu.settings',
    icon: SettingsOutlined,
    subSections: [
      {
        name: 'menu.settings',
        path: '/settings',
        accessKey: 'SETTINGS',
      },
    ],
  },
];

export const handleAnalytics = (
  name: string,
  sendAnalytic: (e: any) => void,
) => {
  switch (name) {
    case 'Chat': {
      sendAnalytic('Chat'); // use const variables here.
      break;
    }
    case 'Discover': {
      sendAnalytic('Discover'); // use const variables here.
      break;
    }
    default: {
      break;
    }
  }
};
